<app-basic-textfield
  [placeholder]="placeholder || 'Search'"
  icon="search"
  (enter)="handleEnter()"
  [formControl]="query"
></app-basic-textfield>
